import axios from 'axios'
import store from "../store";
import { inject } from 'vue'
const toast = inject('toast')

import dotenv from 'dotenv';
dotenv.config();

// const apiUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.5.11:8081/' : process.env.VUE_APP_BASE_URL;     // 本地
const apiUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.5.7:8873/' : process.env.VUE_APP_BASE_URL;   // 测试
// 本地只将已确认的内容查询发往正式接口；提交、上传和埋点仍使用测试接口。
const publicReadPaths = new Set([
    '/api/product/list',
    '/api/product/detail',
    '/api/product/sku/list',
    '/api/product/comment/list',
    '/api/home/product/list',
    '/api/news/list',
    '/api/team/introduce/list',
    '/api/team/list',
    '/api/partner/list',
    '/api/update/log/list',
])
// const apiUrl =  process.env.VUE_APP_BASE_URL;
// const apiUrl = process.env.VUE_APP_BASE_URL;
const service = axios.create({
    baseURL:  apiUrl, // url = base url + request url
    timeout: 5000
    // withCredentials: true // send cookies when cross-domain requests
})


// Request interceptors
service.interceptors.request.use(
    (config) => {
        const useProductionReadApi = process.env.NODE_ENV == 'development' && publicReadPaths.has(config.url || '')
        if (useProductionReadApi) {
            config.baseURL = process.env.VUE_APP_BASE_URL
            // 公开查询不携带本地测试环境的登录凭据。
            delete config.headers['Authorization']
        }
        // Add X-Access-Token header to every request, you can add other custom headers here
        if (!useProductionReadApi && store.getters.GET_TOKEN) {
            config.headers['Authorization'] = store.getters.GET_TOKEN
        }
        return config
    },
    (error) => {
        Promise.reject(error)
    }
)

// Response interceptors
service.interceptors.response.use(
    (response) => {

        const res = response.data
        if (res.code !== 200) {
            // ElMessage({
            //     message: res.msg || 'Error',
            //     type: 'error',
            //     duration: 5 * 1000
            // })
            if (res.code === 2003 || res.code === 2005) {
                store.commit('REMOVE_TOKEN')
                window.location.hash = '/login'
            }
            return Promise.reject(res.msg)
        }else {
            return response.data
        }
    },
    (error) => {
        // ElMessage({
        //     message: error.msg,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

export default service
